<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h4>
                {{
                    "dashboardBizzDev.overview.bizzmine.title.fullLabel"
                        | translate
                }}
            </h4>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <section class="tab-content">
            <table
                mat-table
                [dataSource]="dataSource"
                matSort
                multiTemplateDataRows
            >
                <!-- Subject Column -->
                <ng-container matColumnDef="subject">
                    <tr>
                        <th
                            class="labelTextHeader"
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >
                            {{
                                "dashboardBizzDev.overview.bizzmine.subject.fullLabel"
                                    | translate
                            }}
                        </th>
                    </tr>
                    <tr>
                        <td
                            class="labelButton"
                            mat-cell
                            *matCellDef="let element"
                        >
                            {{ element.subject }}
                        </td>
                    </tr>
                </ng-container>

                <!-- Description column -->
                <ng-container matColumnDef="description">
                    <tr>
                        <th
                            class="labelNumberHeader"
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >
                            {{
                                "dashboardBizzDev.overview.bizzmine.description.fullLabel"
                                    | translate
                            }}
                        </th>
                    </tr>
                    <tr>
                        <td
                            class="labelRowNumber"
                            mat-cell
                            *matCellDef="let element"
                        >
                            <p [innerText]="element.description"></p>
                        </td>
                    </tr>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                    mat-row
                    *matRowDef="let element; columns: displayedColumns"
                ></tr>
            </table>
        </section>
    </mat-card-content>
</mat-card>
